export default {
  intro_title: 'Help us choose our Tour de France jersey',
  intro_button: 'Get started',

  cta_button: 'Vote for favourite jersey',

  hero_switch_dark: 'dark',
  hero_switch_light: 'light',

  story_subtitle: 'Team Visma | Lease a Bike',
  story_title: 'The Architect',
  story_text_line1: 'Inspired by Gaudí and the spirit of Barcelona.',
  story_text_line2: 'Connected through the honeycomb.',
  story_text_line3: 'Ready to build success.',

  customize_title: 'Truly make it your own',
  customize_text: 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',

  training_kit_title: 'Our official training kit',
  training_kit_text: 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',
  training_kit_button: 'Pre-Order training kit',

  countdown_days: 'days',
  countdown_hours: 'hours',
  countdown_minutes: 'minutes',

  vote_title: 'Choose our 2026 Tour de France jersey',
  vote_text: 'Your vote matters',
  vote_percentage: 'of the votes',
  vote_success_title: 'Thank you!',
  vote_success_text: "Your vote has been saved. We will announce the winning shirt soon!",
  vote_form_subtitle_favorite: 'Pick your favourite',
  vote_form_subtitle_confirm: 'Confirm your vote',
  vote_form_button_dark: 'Choose dark',
  vote_form_button_light: 'Choose light',
  vote_form_firstname_label: 'First name',
  vote_form_firstname_placeholder: 'Enter your first name',
  vote_form_email_label: 'Email',
  vote_form_email_placeholder: 'Enter your email',
  vote_form_terms_label: 'I agree to the <a href="/files/EN_Actievoorwaarden_The_Architect_Team_Visma_Lease_a_Bike.pdf" target="_blank">terms and conditions</a>',
  vote_form_marketing_label: 'Yes, I would like to receive interesting promotions from partners of Team Visma | Lease a Bike and/or third parties',
  vote_form_submit_button: 'Submit vote',
  vote_form_error_jersey: 'Please select a jersey.',
  vote_form_error_required: 'This field is required.',
  vote_form_error_email_invalid: 'Please enter a valid email address.',
  vote_form_error_missing_parameters: 'Please fill in all required fields.',
  vote_form_error_invalid_email: 'Please enter a valid email address.',
  vote_form_error_something_went_wrong: 'Something went wrong. Please try again.',

  vote_done_title: 'Thanks for voting!',
  vote_done_text: 'Our new Tour de France jersey will be revealed soon.',
};
